import { PhpFloat, intval, floatval, is_numeric, PHP_INT_MIN, PHP_INT_MAX, type PhpInt } from './values';
import { phpAdd, type PhpArithmetic } from '../compile/php-integer-arithmetic';

/** PHP 8 numeric addition: integer strings retain int64; decimal/exponent
 * strings and overflow produce doubles. Leading numeric strings warn. */
export function add(left: unknown, right: unknown, warn: (message: string, severity: number) => void): PhpInt | PhpFloat {
    const type = (v: unknown): string => v instanceof PhpFloat ? 'float' : v === null || v === undefined ? 'null' : typeof v === 'number' ? Number.isSafeInteger(v) ? 'int' : 'float' : typeof v === 'bigint' ? 'int' : typeof v === 'boolean' ? 'bool' : typeof v === 'string' ? 'string' : 'array';
    const operand = (v: unknown): PhpArithmetic => {
        if (typeof v === 'string') {
            const token = v.match(/^[\t\n\r\v\f ]*([+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)/i)?.[1];
            if (!token) throw new TypeError(`Unsupported operand types: ${type(left)} + ${type(right)}`);
            if (!is_numeric(v)) warn('A non-numeric value encountered', 2);
            if (/^[+-]?\d+$/.test(token)) {
                const n = BigInt(token); if (n >= PHP_INT_MIN && n <= PHP_INT_MAX) return n;
            }
            return Number(floatval(token));
        }
        if (v instanceof PhpFloat || typeof v === 'number' && !Number.isSafeInteger(v)) return Number(floatval(v));
        if (v == null || typeof v === 'boolean' || typeof v === 'number' || typeof v === 'bigint') return BigInt(intval(v));
        throw new TypeError(`Unsupported operand types: ${type(left)} + ${type(right)}`);
    };
    const result = phpAdd(operand(left), operand(right));
    return typeof result === 'bigint' ? intval(result) : new PhpFloat(result);
}
